import { useState } from "react";
import {
  Modal, Box, Typography, Button, FormControl, TextField, Grid
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

const modalStyle = {
  bgcolor: "background.paper",
  boxShadow: 24,
  left: "50%",
  maxWidth: "720px",
  p: 4,
  position: "absolute",
  top: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%"
};

const ChargeAccountAnnexeModal = ({
  open, onClose, onAddAnnexeURL
}) => {
  const [name, setName] = useState('');
  const [url, setUrl] = useState('');  
  const [urlError, setUrlError] = useState('');

  const handleSubmit = async (evt) => {
    evt.preventDefault();

    const urlPattern = /^(https?:\/\/)?([\w\-]+\.)+[\w\-]+(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i; // eslint-disable-line
    if (!urlPattern.test(url)) {
      setUrlError("Por favor ingrese una URL válida.");
      return;
    }

    onAddAnnexeURL({
      id: `${name}.url`,
      name,
      url
    });
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
    >
      <Box sx={modalStyle}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="h6" sx={{ flex: 1 }}>Agregar URL conmo anexo</Typography>
          <CloseIcon sx={{ cursor: 'pointer' }} onClick={onClose} />
        </Box>

        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                required
                label="Nombre del anexo"
                value={name}
                onChange={(evt) => setName(evt.target.value)}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                required
                label="URL del anexo"
                value={url}
                onChange={(evt) => {
                  setUrlError('');
                  setUrl(evt.target.value.trim());
                }}
              />
              {urlError
                && <Typography sx={{ fontSize: '0.875rem', mt: 1 }} color="error">
                  {urlError}
                </Typography>
              }
            </FormControl>
          </Grid>
        </Grid>

        <Button
          type="submit"
          variant="contained"
          sx={{ mt: 5 }}
          onClick={handleSubmit}
        >
          Guardar
        </Button>
      </Box>
    </Modal>
  );
};

export default ChargeAccountAnnexeModal;
